export const checkQueryParams = (query: URLSearchParams) => {
  const hasSearchParams =
    !!query.get('search') &&
    query.get('search') !== '{}' &&
    query.get('search')?.trim() !== '';
  const hasFilterParams =
    !!query.get('filters') &&
    query.get('filters') !== '{}' &&
    query.get('filters')?.trim() !== '';
  const hasBetweenParams =
    !!query.get('between') &&
    query.get('between') !== '{}' &&
    query.get('between')?.trim() !== '';

  return { hasSearchParams, hasFilterParams, hasBetweenParams };
};

export const shouldShowSetup = (
  tableData: any[],
  setupForMe: boolean | undefined,
  queryParams: URLSearchParams
) => {
  const { hasSearchParams, hasFilterParams, hasBetweenParams } =
    checkQueryParams(queryParams);
  return (
    setupForMe &&
    tableData.length === 0 &&
    !hasSearchParams &&
    !hasFilterParams &&
    !hasBetweenParams
  );
};

export const shouldShowEmpty = (
  tableData: any[],
  queryParams: URLSearchParams,
  setupForMe?: boolean
) => {
  const { hasSearchParams, hasFilterParams, hasBetweenParams } =
    checkQueryParams(queryParams);

  const noFilters = !hasSearchParams && !hasFilterParams && !hasBetweenParams;

  return (
    tableData.length === 0 &&
    (hasSearchParams || hasFilterParams || hasBetweenParams || !setupForMe)
  );
};
